<template>
  <div id="reserver-transport" class="bloc_reserver_transport">
    <div class="overlap-group4-5">
      <img class="icon-car-2" src="../../img/transport---car-2@2x.png" alt="icon-car" />
      <div class="ellipse-inscription"></div>
      <p class="reserver-votre-trans isidorasansalt-bold-white-28px">
        <span class="isidorasansalt-bold-white-28px">RESERVER VOTRE TRANSPORT</span
        ><br><span class="span-50 blogintro">En moins de 30 secondes avec Pop Valet et gagnez du temps</span>
      </p>
    </div>
    <div class="inscription-3">
      <div class="rserver-mon-transport isidorasansalt-bold-white-28px">RÉSERVER MON TRANSPORT</div>
      <ValidationObserver v-slot="{handleSubmit}" ref="form">
        <form @submit.prevent="handleSubmit(sendEmail)">
          <div class="champs_inscription">
            <ValidationProvider rules="required" v-slot="{errors}">
              <input type="text" v-model="contactName" class="text-field" :class="{'text-field-error': errors[0]}" placeholder="Nom contact"/>
              <div v-if="errors[0]" class="error">Champ requis</div>
            </ValidationProvider>

            <ValidationProvider rules="required" v-slot="{errors}">
              <input type="email" v-model="email" class="text-field" :class="{'text-field-error': errors[0]}" placeholder="Email"/>
              <div v-if="errors[0]" class="error">Champ requis</div>
            </ValidationProvider>

            <ValidationProvider rules="required" v-slot="{errors}">
              <input type="tel" v-model="phone" class="text-field" :class="{'text-field-error': errors[0]}" placeholder="Téléphone"/>
              <div v-if="errors[0]" class="error">Champ requis</div>
            </ValidationProvider>

            <ValidationProvider rules="required" v-slot="{errors}">
              <input type="text" v-model="fromAddress" class="text-field" :class="{'text-field-error': errors[0]}" placeholder="Adresse de départ"/>
              <div v-if="errors[0]" class="error">Champ requis</div>
            </ValidationProvider>

            <ValidationProvider rules="required" v-slot="{errors}">
              <input type="text" v-model="toAddress" class="text-field" :class="{'text-field-error': errors[0]}" placeholder="Adresse d'arrivée"/>
              <div v-if="errors[0]" class="error">Champ requis</div>
            </ValidationProvider>

            <ValidationProvider rules="required" v-slot="{errors}">
              <textarea v-model="message" class="text-field" :class="{'text-field-error': errors[0]}" placeholder="Decrivez votre besoin"></textarea>
              <div v-if="errors[0]" class="error">Champ requis</div>
            </ValidationProvider>

            <button class="submit-button" type="submit">JE RÉSERVE MON TRANSPORT</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import {Simplert} from "vue2-simplert-plugin";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import axios from "axios";
export default {
  name: "BlocReserverTransport",
  components: {
    Simplert,
    ValidationProvider,
    ValidationObserver
  },
  data: function() {
    return {
      contactName: '',
      email: '',
      phone: '',
      fromAddress: '',
      toAddress: '',
      message: ''
    };
  },
  methods: {
    sendEmail: async function () {
      try {
        const apiUrl = location.host === 'www.popvalet.com'
            ? 'https://admin-api.popvalet.com'
            : 'https://admin-beta-api.popvalet.com';

        await axios.post(apiUrl + '/website/email-particulier', {
          contactName: this.contactName,
          email: this.email,
          phone: this.phone,
          fromAddress: this.fromAddress,
          toAddress: this.toAddress,
          message: this.message
        });

        this.$Simplert.open({
          message: 'Demande de transport envoyée avec succès !',
          type: 'success',
          customClass: 'pv-popup',
          customCloseBtnText: 'Fermer',
          customCloseBtnClass: 'pv-popup-close-button'
        });

        this.contactName = '';
        this.email = '';
        this.phone = '';
        this.fromAddress = '';
        this.toAddress = '';
        this.message = '';

        this.$nextTick(() => {
          this.$refs.form.reset();
        });

      } catch (error) {
        this.$Simplert.open({
          message: 'Erreur lors de l\'envoi de la demande de transport.',
          type: 'error',
          customClass: 'pv-popup',
          customCloseBtnText: 'Fermer',
          customCloseBtnClass: 'pv-popup-close-button'
        });
      }
    }
  }
};
</script>

<style scoped>
.text-field {
  width: 100%;
  background-color: var(--bluenavy);
  border: 1px solid;
  border-color: var(--blanc);
  border-radius: 30px;
  height: 44px;
  padding: 10px;
  color: white;
  font-family: var(--font-family-montserrat);
  font-size: var(--font-size-xxs);
  font-style: normal;
  font-weight: 400;
}

.text-field::placeholder {
  opacity: 0.7;
  color: white;
}

.error {
  margin-top: 5px;
  font-family: var(--font-family-montserrat);
  font-size: var(--font-size-xxs);
  font-style: normal;
  font-weight: 400;
  color: red;
}

.text-field-error {
  border-color: red;
}

textarea {
  min-height: 150px;
 resize: vertical;
}


.bloc_reserver_transport {
  align-items: flex-start;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  background-color: var(--bluenavy);
  border-radius: 8px;
  margin-top: 44px;
  max-width: 1200px;
  width: 100%;
  padding: 50px 0;
  gap: 30px;
}

.overlap-group4-5 {
  align-self: center;
  height: 234px;
  margin-bottom: 2px;
  position: relative;
  width: 418px;
}

.icon-car-2 {
  height: 84px;
  left: 167px;
  position: absolute;
  top: 19px;
  width: 84px;
}

.ellipse-inscription {
  background-color: var(--white);
  border-radius: 117px;
  height: 234px;
  left: 92px;
  position: absolute;
  top: 0;
  width: 234px;
}

.reserver-votre-trans {
  left: 0;
  letter-spacing: 0;
  line-height: 28px;
  position: absolute;
  text-align: center;
  top: 94px;
}

.span-50 {
  color: var(--blanc);
  font-weight: 400;
  line-height: 28px;
}

.inscription-3 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 34px;
  position: relative;
  width: fit-content;
}
.inscription-3 > span {
  width: 100%
}

.rserver-mon-transport {
  letter-spacing: 0;
  line-height: normal;
  text-align: center;
}

.champs_inscription {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  width: 100%;
}
.champs_inscription > * {
  width: 100%;
}

.submit-button {
  width: 100%;
  background-color: var(--violetclair);
  border: none;
  border-radius: 34px;
  padding: 12px 0;
  font-family: var(--font-family-montserrat);
  font-size: var(--font-size-xxs);
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0;
  color: var(--bluenavy);
  cursor: pointer;
}
</style>
